import type { ReactNode } from 'react';
import { Avatar, type AvatarProperties } from '../../../avatar';
import { Flex } from '../../../flex';
import { MessagePreview } from './message-preview';
import styles from './preview.module.css';

export type PreviewProperties = {
  lastMessage: MessagesSidebarItemLastMessage;
  seenBy?: Array<{ id: string } & AvatarProperties>;
  unread?: boolean;
};

type MessagesSidebarItemLastMessage = {
  author?: string;
  message: { icon?: ReactNode; text: string } | string;
};

const Preview = ({ lastMessage: { author, message }, seenBy, unread }: PreviewProperties) => (
  <Flex align="center" gap="xxs">
    <MessagePreview author={author} message={message} unread={unread} />
    {seenBy && seenBy.length > 0 ? (
      <Avatar.Group className={styles['seen-by']} max={{ count: 4 }} size="xs">
        {seenBy.map((participant) => (
          <Avatar key={participant.id} {...participant} />
        ))}
      </Avatar.Group>
    ) : null}
  </Flex>
);

export default Preview;
